var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFaster = function SvgFaster(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "faster_svg__Zeichenfl\\xE4che_1_1_",
    x: 0,
    y: 0,
    viewBox: "0 0 3971 4175",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".faster_svg__faster0{opacity:.99;fill:none;stroke:#575d6b;stroke-width:358;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "faster_svg__Form_1_xA0_Bild_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m351.4 3490.9 1706.8-1706.8 1677.3 1677.3",
    className: "faster_svg__faster0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5 2398.9 2059.4 692l1677.2 1677.3",
    className: "faster_svg__faster0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFaster);
export default ForwardRef;